import { Component, inject } from '@angular/core';
import { VehicleTechnologyService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VehicleTechnologyCreateDto,
  VehicleTechnologyDto,
  VehicleTechnologyExcelDownloadDto,
  VehicleTechnologyUpdateDto,
} from '../proxy/general/dtos/vehicle-technology';
import { VEHICLETECHNOLOGY_CONFIG, VEHICLETECHNOLOGY_FIELDS } from './vehicle-technology.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-vehicle-technology',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VehicleTechnologyService, ConfirmationService],
  templateUrl: './vehicle-technology.html',
  styleUrl: './vehicle-technology.scss',
})
export class VehicleTechnology extends BaseCrudComponent<
  VehicleTechnologyDto,
  VehicleTechnologyCreateDto,
  VehicleTechnologyUpdateDto,
  VehicleTechnologyExcelDownloadDto
> {
  service = inject(VehicleTechnologyService);
  config = VEHICLETECHNOLOGY_CONFIG;
  fields = VEHICLETECHNOLOGY_FIELDS;

  protected prepareUpdateDto(data: any, selected: VehicleTechnologyDto): VehicleTechnologyUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isLowImpactTechnology: data.isLowImpactTechnology,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VehicleTechnology';
  }
}
